import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  makeStyles,
  Field,
  Input,
  Select,
  useId,
  Label,
  Textarea,
  Checkbox,
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Switch,
  Button,
  Tooltip,
  RadioGroup,
  Radio,
  Toaster,
  Spinner,
} from "@fluentui/react-components";
import { useToastMessage } from "../ToastMessage/ToastMessage";
import {
  checkUserPermission,
  formatedDate,
  getFileNameFromUrl,
  getUserDefinedType,
  getUserDefinedTypeValue,
  handleFileDownload,
  stripHtml,
} from "../../utils";
import TimePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import Dropzone from "react-dropzone";
import UploadIcon from "../../assets/uploadicon.svg";
import DynamicDropzone from "../DynamicDropzone/Dropzone";
import { getUserId } from "../../utils";
import CreatableSelect from "react-select/creatable";
import "react-quill/dist/quill.snow.css";
import {
  Dismiss12Filled,
  Dismiss16Regular,
  InfoRegular,
  Copy20Regular,
  FolderOpenRegular,
} from "@fluentui/react-icons";
import TextEditor from "../TextEditor";
import AssystLinkModal from "../ElectronAppFiles/AssystLinkModal";
import { useAssystFilePicker } from "../ElectronAppFiles/useAssystFilePicker";
import { setDialogModalOptions } from "../../redux/modelDialogReducer";
import Provider from "../../pages/client/Provider/Provider";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../redux/store";
import {
  ChevronDown24Filled,
  ChevronDown20Filled,
} from "@fluentui/react-icons";
import apiServices from "../../service";
import { UserPermissionsList } from "../../config";
import ASCButton from "../Button";
import { resetFormData, setFormData } from "../../redux/reducer";
import ControlledDatePicker from "../ControlledDatePicker";
import NoteViewer from "../NoteViewer";
import {
  formatGBP,
  formatGBPOrPassThrough,
  formatPercent,
  getCurrencySymbol,
} from "../../utils/currency";
import RuleAmountInput from "./RuleAmountInput";
import {
  isCurrencyElement,
  isPercentAmountField,
} from "./currencyFieldRules";

// Strips surrounding quotes (ASCII and Unicode smart quotes) from pasted paths
// e.g. "C:\Users\John\file.pdf" → C:\Users\John\file.pdf
const sanitizePath = (value: string): string =>
  value.replace(/["\u201C\u201D'\u2018\u2019]/g, "").trim();

type RenderFormElementsProps = {
  style?: React.CSSProperties;
  [key: string]: any;
};
interface Option {
  readonly label: string;
  readonly value: string;
}
const useStyles = makeStyles({
  fieldWrapper: {
    // display: "grid",
    display: "flex",
    width: "100%",
    wordBreak: "break-word",
    // gridTemplateColumns: "3fr 4fr",
    // gap: "10px",

    flexDirection: "column",
    justifyContent: "center",
  },
  title: {
    fontSize: "12px",
  },
  subTitle: {
    fontSize: "14px",
  },
});

const createOption = (label: string) => ({
  label,
  value: label,
});
const defaultOptions = [createOption("")];

const RenderFormElements = (props: RenderFormElementsProps) => {
  const selectedruleItem = useSelector(
    (state: any) => state.ruleid?.selectedRule,
  );
  let { formik } = props;
  const selectId = useId();
  const classes = useStyles();
  const [checked, setChecked] = React.useState(false);
  const [checkedData, setCheckedData] = React.useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(defaultOptions);
  const [value, setValue] = useState<Option | null>();
  const [openTextEditor, setOpenTextEditor] = useState(false);
  const [valueLoader, setValueLoader] = useState(true);
  const [openProviderList, setOpenProviderList] = useState(false);
  const { showToast, toasterId } = useToastMessage();

  const [toggle, setToggle] = useState(false);
  const [uploadMode, setUploadMode] = useState<"upload" | "fileLink" | null>(
    null,
  );
  const [assystLinkOpen, setAssystLinkOpen] = useState(false);
  const {
    pickFile,
    openFile,
    isLoading: isPickerLoading,
    needsUpdate,
    latestVersion,
    platform,
    installerName,
    downloadUrl,
  } = useAssystFilePicker();
  useEffect(() => {
    props?.setIsPickerLoading?.(isPickerLoading);
  }, [isPickerLoading]);
  const prevModeRef = useRef<string | undefined>(undefined);
  const [fileLinkPath, setFileLinkPath] = useState("");
  const originalRefPath = useRef("");
  const [rawFiles, setRawFiles] = useState<File[]>([]);
  const [scannedFiles, setScannedFiles] = useState<any[]>([]);
  const userId = getUserId();
  const dispatch: AppDispatch = useDispatch();
  const [getProviderId, setGetProviderId] = useState<{ [key: string]: any }>(
    {},
  );

  const [providerName, setProviderName] = useState<string>("");
  const [getRuleId, setGetRuleId] = useState<{ [key: string]: any }>({});
  const [selectedProviderItem, setSelectedProviderItem] = useState<{
    [key: string]: any;
  }>({});
  const providerSnapshotRef = useRef<{
    providerName: string;
    getProviderId: { [key: string]: any };
    selectedProviderItem: { [key: string]: any };
    provider_correspondence: string;
    provider_name: string;
  }>({
    providerName: "",
    getProviderId: {},
    selectedProviderItem: {},
    provider_correspondence: "",
    provider_name: "",
  });
  const loggedUser = useSelector((state: RootState) => state.authUser);
  const isFormDataUpdated = useSelector(
    (state: RootState) => state.someReducer?.isFormDataUpdated,
  );

  // When Formik reinitializes (record opened/reopened), discard any in-progress upload
  // so a cancelled upload from a previous session doesn't carry over.
  const prevInitialValuesRef = useRef(formik.initialValues);
  useEffect(() => {
    if (prevInitialValuesRef.current !== formik.initialValues) {
      prevInitialValuesRef.current = formik.initialValues;
      if (rawFiles.length > 0) {
        setRawFiles([]);
        setScannedFiles([]);
      }
    }
  }, [formik.initialValues]);

  useEffect(() => {
    const prevMode = prevModeRef.current;
    prevModeRef.current = props.mode;

    if (props.mode === "add") {
      // Only reset when transitioning INTO add mode, not on every file_source change.
      // Without this guard, the radio onChange sets file_source which triggers this
      // effect and immediately resets uploadMode back to null.
      if (prevMode !== "add") {
        setUploadMode(null);
        setFileLinkPath("");
        originalRefPath.current = "";
        setRawFiles([]);
        setScannedFiles([]);
      }
      return;
    }
    if (props.mode !== "edit") return;
    if (formik.values.file_source === "UPLOAD") {
      setUploadMode("upload");
      setFileLinkPath("");
      // Do NOT clear originalRefPath here — preserve it so switching back to REFERENCE restores the path
    } else if (formik.values.file_source === "REFERENCE") {
      setUploadMode("fileLink");
      const apiPath =
        formik.values.attachments?.[0]?.FileLink ||
        formik.values.file_link ||
        "";
      // Only lock in originalRefPath once we have an actual value from the API
      if (apiPath && !originalRefPath.current) {
        originalRefPath.current = apiPath;
      }
      setFileLinkPath(originalRefPath.current || apiPath);
    } else {
      setUploadMode(null);
      setFileLinkPath("");
      originalRefPath.current = "";
    }
  }, [
    props.mode,
    formik.values.file_source,
    formik.values.attachments?.[0]?.FileLink,
  ]);

  useEffect(() => {
    if (props.mode === "view") return;
    if (formik.values.first_names === undefined) return;
    const derived =
      formik.values?.first_names?.trim()?.charAt(0)?.toUpperCase() || "";
    formik.setFieldValue("initials", derived);
  }, [formik.values?.first_names]);

  useEffect(() => {
    if (props.mode === "view") return;
    // This form doesn't have a name/title field at all (e.g. payments,
    // withdrawals, actions, valuations) — don't inject an address_name key
    // that isn't part of this form's schema.
    if (
      formik.values?.title === undefined &&
      formik.values?.initials === undefined &&
      formik.values?.last_name === undefined
    ) {
      return;
    }
    const derived = [
      formik.values?.title,
      formik.values?.initials,
      formik.values?.last_name,
    ]
      .filter(Boolean)
      .join(" ");
    formik.setFieldValue("address_name", derived);
  }, [formik.values?.title, formik.values?.initials, formik.values?.last_name]);

  function providerId(id: { [key: string]: any }) {
    setGetProviderId(id);

    if (props?.item?.field) {
      formik.setFieldValue(props?.item?.field, id.id);
    }
  }
  function ruleId(id: { [key: string]: any }) {
    setGetRuleId(id);

    if (props?.item?.field) {
      formik.setFieldValue(props?.item?.field, id.id);
    }
  }

  const selectedProvider = () => {
    if (
      selectedProviderItem &&
      Object.keys(selectedProviderItem).length !== 0
    ) {
      setProviderName(selectedProviderItem?.provider_name);
      providerId(selectedProviderItem);
      formik.setFieldValue(
        "provider_name",
        selectedProviderItem?.provider_name || "",
      );
    }
  };
  const providerDialogOptions = React.useMemo(
    () => ({ getProviderId }),
    [openProviderList],
  );
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleWheel = (event: WheelEvent) => {
      if (
        inputRef.current &&
        inputRef.current.contains(document.activeElement)
      ) {
        inputRef.current.blur();
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 0);
      }
    };

    document.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);

  useEffect(() => {
    setValue(null);
    setOptions(props?.options ? props?.options : defaultOptions);

    if (
      props?.options &&
      !valueLoader &&
      props?.item &&
      props?.item?.listType &&
      ["ModifiableList", "MasterDatawithNewEntry"].includes(
        props?.item?.listType,
      )
    ) {
      setOptions(props.options);
      const valueIs = formik.values[props?.item?.field];
      let isValuePresent = false;

      if (
        props?.options !== undefined &&
        props?.option !== null &&
        props?.options?.length > 0 &&
        valueIs !== undefined &&
        valueIs !== null
      ) {
        isValuePresent = props?.options?.some(
          (obj: any) =>
            obj?.value != null &&
            valueIs != null &&
            String(obj.value).toLowerCase() === String(valueIs).toLowerCase(),
        );
      }

      if (valueIs !== "" && valueIs !== null) {
        const newOption = createOption(valueIs);
        setValue(newOption);

        if (!isValuePresent) {
          setOptions((prev) => [...prev, newOption]);
        }
      } else {
        setValue(null);
      }
    }

    return () => {
      setValue(null);
    };
  }, [props?.options, valueLoader, formik.values]);

  useEffect(() => {
    if (formik.values[props.item.field] !== undefined) {
      setValueLoader(false);
    }
  }, [formik.values[props.item.field]]);

  useEffect(() => {
    if (props.caseDetails !== undefined) {
      setGetProviderId(props.caseDetails);
      setProviderName(props.caseDetails?.provider_name);
    }
  }, [props.caseDetails]);

  useEffect(() => {
    if (formik.values.provider_name !== undefined) {
      setProviderName(formik.values.provider_name || "");
    }
  }, [formik.values.provider_name]);

  useEffect(() => {
    const providerIdInForm = formik.values[props.item.field];
    if (
      providerIdInForm !== undefined &&
      providerIdInForm !== getProviderId.id
    ) {
      if (!providerIdInForm) {
        setGetProviderId({});
      } else {
        setGetProviderId((prev) => ({ ...prev, id: providerIdInForm }));
      }
    }
  }, [formik.values[props.item.field], getProviderId.id]);

  useEffect(() => {
    // Fund fields don't exist on this form (e.g. payments, withdrawals,
    // actions, valuations) — parseFloat(undefined) is NaN, and NaN !== 0 is
    // true, so without this guard every form would get a stray, NaN-valued
    // fund_value/fund_units/unit_price key injected into formik.values.
    if (
      formik.values.unit_price === undefined &&
      formik.values.fund_units === undefined &&
      formik.values.fund_value === undefined
    ) {
      return;
    }
    if (
      parseFloat(formik.values.unit_price) !== 0 &&
      parseFloat(formik.values.fund_units) !== 0
    ) {
      formik.setFieldValue(
        "fund_value",
        parseFloat(
          (formik.values.unit_price * formik.values.fund_units).toFixed(4),
        ),
      );
    }
  }, [formik.values.unit_price, formik.values.fund_units]);

  useEffect(() => {
    if (
      formik.values.unit_price === undefined &&
      formik.values.fund_units === undefined &&
      formik.values.fund_value === undefined
    ) {
      return;
    }
    if (
      parseFloat(formik.values.fund_value) !== 0 &&
      parseFloat(formik.values.unit_price) !== 0 &&
      parseFloat(formik.values.fund_units) === 0
    ) {
      formik.setFieldValue(
        "fund_units",
        parseFloat(
          (formik.values.fund_value / formik.values.unit_price).toFixed(4),
        ),
      );
    }
  }, [formik.values.fund_value, formik.values.unit_price]);

  useEffect(() => {
    if (
      formik.values.unit_price === undefined &&
      formik.values.fund_units === undefined &&
      formik.values.fund_value === undefined
    ) {
      return;
    }
    if (
      parseFloat(formik.values.fund_value) !== 0 &&
      parseFloat(formik.values.fund_units) !== 0 &&
      parseFloat(formik.values.unit_price) === 0
    ) {
      formik.setFieldValue(
        "unit_price",
        parseFloat(
          (formik.values.fund_value / formik.values.fund_units).toFixed(4),
        ),
      );
    }
  }, [formik.values.fund_value, formik.values.fund_units]);

  useEffect(() => {
    if (
      (props.mode === "add" || props.mode === "edit") &&
      (props.context === "ASSET_INVESTMENT_COMMISSION_DISTRIBUTION" ||
        props.context === "LIABILITIES_MORTGAGES_COMMISSION_DISTRIBUTION" ||
        props.context ===
          "LIABILITIES_LOAN_HIRE_PURCHASE_COMMISSION_DISTRIBUTION" ||
        props.context === "POLICIES_LIFE_ASSURANCE_COMMISSION_DISTRIBUTION" ||
        props.context === "POLICIES_PENSIONS_COMMISSION_DISTRIBUTION" ||
        props.context === "POLICIES_INVESTMENTS_COMMISSION_DISTRIBUTION" ||
        props.context === "POLICIES_SAVINGS_PLANS_COMMISSION_DISTRIBUTION" ||
        props.context ===
          "POLICIES_INCOME_PROTECTION_COMMISSION_DISTRIBUTION" ||
        props.context === "POLICIES_HEALTH_ASSURANCE_COMMISSION_DISTRIBUTION" ||
        props.context === "POLICIES_GENERAL_COMMISSION_DISTRIBUTION") &&
      selectedruleItem
    ) {
      formik.setValues({
        ...formik.values,
        amount: selectedruleItem.amount,
        // Carried across with the amount it describes. Without it the form has
        // the value but no way to know whether it is money or a percentage, so
        // view mode fell back to "money" and painted a percentage rule as
        // "£5.00".
        amount_flag: selectedruleItem.amount_flag,
        party_type: selectedruleItem.party_type || "Consultant",
        party_name: selectedruleItem.party_name,
        commission_rule_id: selectedruleItem.id,
        note_text: selectedruleItem.note_text,
        case_type: caseTypeQuery,
      });
      setValue({
        value: selectedruleItem.party_name,
        label: selectedruleItem.party_name,
      });
      dispatch(setFormData());
    }
  }, [selectedruleItem, props.context]);

  const mapCaseType = (key: string) => {
    const mapping: any = {
      investment: ["Asset (Investment)"],
      morgages: ["Mortgages"],
      "loans-lease-hp": ["Loans"],
      "Life Assurance": ["Life Assurance"],
      Pensions: ["Pensions"],
      Investments: ["Investments"],
      "Savings Plans": ["Savings Plans"],
      "Income Protection": ["Income Protection"],
      "Health Assurance": ["Health Assurance"],
      General: ["General"],
    };

    return mapping[key] || [key];
  };

  const buildCaseTypeQuery = (key: string | undefined) => {
    if (!key) return "";
    const mapped = mapCaseType(key);
    return mapped;
  };
  const caseTypeQuery = buildCaseTypeQuery(props.caseType);
  useEffect(() => {
    if (props.mode === "add" && formik.values.provider_correspondence) {
      setGetProviderId({ id: "" });
      setProviderName("");

      formik.setFieldValue("provider_correspondence", "");
    }
  }, [props.mode]);
  const handleCreate = (inputValue: string, name: string) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = createOption(inputValue);
      setIsLoading(false);
      setValue(newOption);
      formik.setFieldValue(name, inputValue);
      if (props.newSelectOptionAdded !== undefined) {
        props.newSelectOptionAdded(name, newOption, "add");
      }
    }, 1000);
  };

  const validateMaxMinDate = (date: any) => {
    if (date && date !== undefined) {
      if (date === "today") {
        return new Date();
      } else {
        return new Date(date);
      }
    } else {
      return undefined;
    }
  };
  const timeAllocation = props.context === "CONTACTS_TIME_ALLOCATION";

  useEffect(() => {
    const { context, mode } = props;

    if (context === "MASTER_SETTINGS_USER_DEFINED") {
      const typeValue = formik.values?.type;

      // Edit mode: convert label like "Integer" to numeric string
      if (mode === "edit") {
        if (typeof typeValue === "string" && isNaN(Number(typeValue))) {
          const numericValue = getUserDefinedTypeValue(typeValue);
          if (numericValue !== null) {
            formik.setFieldValue("type", String(numericValue));
          }
        }
      }

      if (mode === "view") {
        if (["0", "1", "2", "3"].includes(typeValue)) {
          const parsed = parseInt(typeValue);
          const label = getUserDefinedType(parsed);
          formik.setFieldValue("type", label);
        }
      }
    }
  }, [formik.values?.type, props.context, props.mode]);
  const HandleNoteChange = useCallback(
    (text: string) => {
      const fieldName = props?.item?.field;
      const cleanedText = stripHtml(text).trim();
      const sanitizedText =
        /^(<p>\s*<br>\s*<\/p>|\s*)$/i.test(text.trim()) || cleanedText === ""
          ? ""
          : text;

      formik.setFieldValue(fieldName, sanitizedText);
      formik.setFieldError(
        fieldName,
        sanitizedText ? undefined : formik.errors[fieldName],
      );

      if (props.customHandleChange) {
        props.customHandleChange({
          target: { name: fieldName, value: sanitizedText },
        });
      }
      if (!cleanedText) {
        dispatch(resetFormData());
      }
    },
    [props?.item?.field, formik.errors, props.customHandleChange, dispatch],
  );

  const getElement = (element: any) => {
    const fieldInfo = {
      name: element.field,
      label: element.label,
      options: element.options,
      placeholder: element.placeholder ? element.placeholder : "",
      readOnly: element.readOnly ? element.readOnly : false,
      required: element.required ? element.required : undefined,
      info: element.info ? element.info : undefined,
      min: element.min ? element.min : undefined,
      max: element.max ? element.max : undefined,
    };
    const review = [
      "review_assigned",
      "business_assigned",
      "appointment_assigned",
    ].includes(fieldInfo.name);
    const handleClearDate = () => {
      formik.setFieldValue(fieldInfo.name, null);
      if (props.customHandleChange !== undefined) {
        props.customHandleChange({
          target: { name: fieldInfo.name, value: null },
        });
      }
    };
    const handleManualInput = (value: string) => {
      let sanitizedValue = value.replace(/[^0-9:]/g, "");

      const timeParts = sanitizedValue.split(":").slice(0, 3);

      let [hh, mm, ss] = timeParts.map((num) =>
        num ? parseInt(num, 10) : undefined,
      );
      if (hh !== undefined) {
        if (hh < 0) hh = 0;
        if (hh > 23) hh = 23;
      } else {
        hh = 0;
      }
      if (mm !== undefined) {
        if (mm < 0) mm = 0;
        if (mm > 59) mm = 59;
      } else {
        mm = 0;
      }
      if (ss !== undefined) {
        if (ss < 0) ss = 0;
        if (ss > 59) ss = 59;
      } else {
        ss = 0;
      }

      // Build normalized time string HH:mm:ss
      const normalized = `${String(hh).padStart(2, "0")}:${String(mm).padStart(
        2,
        "0",
      )}:${String(ss).padStart(2, "0")}`;
      const now = new Date();
      const date = new Date(
        Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), hh, mm, ss),
      );
      formik.setFieldValue(fieldInfo.name, date.toISOString());
    };
    const parseTime = (
      timeString: string | undefined | null,
      fieldName?: string,
    ): Date | null => {
      if (!timeString) return null;

      const time = String(timeString).trim();

      // Handle duration fields
      if (fieldName === "duration") {
        // Support both timestamp and time string formats
        const timestamp = Number(time);
        if (!isNaN(timestamp)) {
          // Convert timestamp to local Date
          const date = new Date(timestamp);
          // Validate time components
          if (
            date.getHours() <= 23 &&
            date.getMinutes() <= 59 &&
            date.getSeconds() <= 59
          ) {
            return date;
          }
        }

        // Handle time string format (HH:mm or HH:mm:ss)
        const parts = time.includes("T")
          ? time.split("T")[1]?.split(":")
          : time.split(":");

        if (parts && parts.length >= 2) {
          const hours = parseInt(parts[0], 10);
          const minutes = parseInt(parts[1], 10);
          const seconds = parts[2] ? parseInt(parts[2], 10) : 0;

          // Validate and clamp values
          const validHours = Math.min(23, Math.max(0, hours));
          const validMinutes = Math.min(59, Math.max(0, minutes));
          const validSeconds = Math.min(59, Math.max(0, seconds));

          const date = new Date();
          date.setHours(validHours, validMinutes, validSeconds, 0);
          return date;
        }
        return null;
      }

      // Handle normal time fields (UTC)
      try {
        // Already a valid UTC timestamp
        if (time.includes("T") && time.includes("Z")) {
          return new Date(time);
        }

        // Handle time string format (HH:mm or HH:mm:ss)
        if (/^\d{1,2}:\d{1,2}(:\d{1,2})?$/.test(time)) {
          const [hours, minutes, seconds] = time.split(":").map(Number);
          const date = new Date();
          date.setUTCHours(hours || 0, minutes || 0, seconds || 0, 0);
          return date;
        }

        const parsed = new Date(time);
        return isNaN(parsed.getTime()) ? null : parsed;
      } catch {
        return null;
      }
    };
    const getIsSelected = (fieldName: string, value: any, optn: any) => {
      const strVal = value?.toString?.() ?? "";

      switch (fieldName) {
        case "uk_residence":
          if (["1", 1, "Yes"].includes(value))
            return optn.value.toString() === "1";
          if (["0", 0, "No"].includes(value))
            return optn.value.toString() === "0";
          return false;

        case "commission_type":
          return value === optn.label;

        case "case_type":
          return value === "Unit-linked"
            ? optn.label === "Asset (Investment)"
            : value === optn.label;

        case "consultant_id":
          return value === optn.value;

        case "applicable":
        case "pending":
        case "link_to_mortgage":
        case "category":
        case "joint_indicator":
        case "owner":
          return strVal === optn.value;

        default:
          return value === optn.value;
      }
    };

    switch (element.type) {
      case "text":
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span>{element.label} </span>
                )}

                {props.primaryContactFields !== undefined &&
                  props.primaryContactFields.length > 0 &&
                  props.primaryContactFields.includes(element.field) && (
                    <>
                      {"("}
                      <Checkbox
                        // style={{ transform: "scale(0.75)" }}
                        checked={
                          props.primaryContact === element.field ? true : false
                        }
                        value={element.field}
                        disabled={
                          formik?.values[fieldInfo.name] !== undefined &&
                          formik?.values[fieldInfo.name] !== null &&
                          formik?.values[fieldInfo.name] !== ""
                            ? false
                            : true
                        }
                        onChange={(ev: any, data: any) => {
                          setCheckedData(data.checked);
                          props.setFieldAsPrimary(
                            data.checked ? ev.target.value : "",
                          );
                        }}
                        label="Set as primary"
                        className="small-checkbox"
                      />
                      {")"}
                    </>
                  )}
              </>
            }
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined &&
              formik.errors[fieldInfo.name] !== null
                ? formik.errors[fieldInfo.name]
                : ""
            }`}

            // validationState="success"
          >
            <Input
              appearance="filled-lighter"
              onChange={(e) => {
                if (fieldInfo.name === "initials") {
                  e.target.value = e.target.value.toUpperCase();
                }
                formik.handleChange(e);
              }}
              onBlur={formik.handleBlur}
              name={fieldInfo.name}
              placeholder={fieldInfo.placeholder}
              disabled={fieldInfo.readOnly}
              value={
                fieldInfo.name === "created_by_name" && props.mode === "add"
                  ? (loggedUser?.userProfileInfo?.full_name ?? "")
                  : formik?.values[fieldInfo.name] !== undefined
                    ? formik.values[fieldInfo.name]
                    : ""
              }
            />
          </Field>
        );
        break;
      case "password":
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
                {props.primaryContactFields !== undefined &&
                  props.primaryContactFields.length > 0 &&
                  props.primaryContactFields.includes(element.field) && (
                    <>
                      {" ("}
                      <Checkbox
                        checked={
                          props.primaryContact === element.field ? true : false
                        }
                        value={element.field}
                        disabled={
                          formik?.values[fieldInfo.name] !== undefined &&
                          formik?.values[fieldInfo.name] !== null &&
                          formik?.values[fieldInfo.name] !== ""
                            ? false
                            : true
                        }
                        onChange={(ev: any, data: any) => {
                          setCheckedData(data.checked);
                          props.setFieldAsPrimary(
                            data.checked ? ev.target.value : "",
                          );
                        }}
                        label="Set as primary"
                      />
                      {")"}
                    </>
                  )}
              </>
            }
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
            // validationState="success"
          >
            <Input
              appearance="filled-lighter"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              name={fieldInfo.name}
              placeholder={fieldInfo.placeholder}
              disabled={fieldInfo.readOnly}
              type="password"
              value={
                formik?.values[fieldInfo.name] !== undefined
                  ? formik.values[fieldInfo.name]
                  : ""
              }
            />
          </Field>
        );
        break;
      case "selection-with-call-to-action":
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
                {props.primaryContactFields !== undefined &&
                  props.primaryContactFields.length > 0 &&
                  props.primaryContactFields.includes(element.field) && (
                    <>
                      {" ("}
                      <Checkbox
                        checked={
                          props.primaryContact === element.field ? true : false
                        }
                        value={element.field}
                        disabled={
                          formik?.values[fieldInfo.name] !== undefined &&
                          formik?.values[fieldInfo.name] !== null &&
                          formik?.values[fieldInfo.name] !== ""
                            ? false
                            : true
                        }
                        onChange={(ev: any, data: any) => {
                          setCheckedData(data.checked);
                          props.setFieldAsPrimary(
                            data.checked ? ev.target.value : "",
                          );
                        }}
                        label="Set as primary"
                      />
                      {")"}
                    </>
                  )}
              </>
            }
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
            // validationState="success"
          >
            {/* <Button
              
              icon={<ChevronDown24Filled />}
            >
              Provider
            </Button> */}
            <div
              className="provider_button"
              onClick={() => {
                // Save snapshot of current provider state before opening dialog
                providerSnapshotRef.current = {
                  providerName: providerName,
                  getProviderId: getProviderId,
                  selectedProviderItem: selectedProviderItem,
                  provider_correspondence:
                    formik.values.provider_correspondence || "",
                  provider_name: formik.values.provider_name || "",
                };
                setOpenProviderList(true);
              }}
              // ALLOW_REASSIGN_ACTIONS
            >
              <Input
                style={{ display: "none" }}
                appearance="filled-lighter"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name={fieldInfo.name}
                placeholder={fieldInfo.placeholder}
                disabled={fieldInfo.readOnly}
                value={getProviderId.id}
              />

              {providerName != "" && providerName !== "undefined" ? (
                <span>{providerName}</span>
              ) : (
                <span></span>
              )}

              <ChevronDown20Filled />
            </div>
          </Field>
        );
        break;
      case "select-call-to-action":
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
                {props.primaryContactFields !== undefined &&
                  props.primaryContactFields.length > 0 &&
                  props.primaryContactFields.includes(element.field) && (
                    <>
                      {" ("}
                      <Checkbox
                        checked={
                          props.primaryContact === element.field ? true : false
                        }
                        value={element.field}
                        disabled={
                          formik?.values[fieldInfo.name] !== undefined &&
                          formik?.values[fieldInfo.name] !== null &&
                          formik?.values[fieldInfo.name] !== ""
                            ? false
                            : true
                        }
                        onChange={(ev: any, data: any) => {
                          setCheckedData(data.checked);
                          props.setFieldAsPrimary(
                            data.checked ? ev.target.value : "",
                          );
                        }}
                        label="Set as primary"
                      />
                      {")"}
                    </>
                  )}
              </>
            }
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
            // validationState="success"
          >
            {/* <Button
              
              icon={<ChevronDown24Filled />}
            >
              Provider
            </Button> */}
            <div
              className="provider_button"
              onClick={() => {
                dispatch(
                  setDialogModalOptions({
                    open: true,
                    rule: true,
                    ruleId: ruleId,
                    getRuleId: getRuleId,
                    cancel: {
                      onclick: () => {
                        dispatch(setDialogModalOptions({ open: false }));
                      },
                      label: "Cancel",
                    },
                    no: {
                      onclick: () => {
                        // setSeletedRule(selectedruleItem);
                        dispatch(setDialogModalOptions({ open: false }));
                      },
                      label: "Select",
                      type: "primary",
                    },
                  }),
                );
              }}
              // ALLOW_REASSIGN_ACTIONS
            >
              <span></span>
              <ChevronDown24Filled />
            </div>
          </Field>
        );
        break;
      case "number": {
        // A rule's amount (the form carries its amount_flag) is shown in the
        // same format as View — "50.00%" or the company currency — while not
        // being edited. Every other number field keeps the plain input.
        const ruleAmountFlag = formik.values?.amount_flag;
        const isRuleAmount =
          element.field === "amount" &&
          ruleAmountFlag !== undefined &&
          ruleAmountFlag !== null &&
          ruleAmountFlag !== "";
        const NumberInput: any = isRuleAmount ? RuleAmountInput : Input;
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
              </>
            }
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
            // validationState="success"
          >
            <NumberInput
              {...(isRuleAmount ? { amountFlag: ruleAmountFlag } : {})}
              appearance="filled-lighter"
              name={fieldInfo.name}
              type="number"
              ref={inputRef}
              placeholder={fieldInfo.placeholder}
              onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                formik.handleBlur(e);
                if (fieldInfo.name === "fund_value") {
                  const fv = parseFloat(e.target.value) || 0;
                  const fu = parseFloat(formik.values.fund_units) || 0;
                  const up = parseFloat(formik.values.unit_price) || 0;

                  if (fv !== 0 && !fu && !up) {
                    // Scenario 1: only fund_value entered — default units to 1,
                    // derive price. Use the literal 1 (not formik.values.fund_units
                    // which is still 0 at this point).
                    formik.setFieldValue("fund_units", 1);
                    formik.setFieldValue(
                      "unit_price",
                      parseFloat((fv / 1).toFixed(4)),
                    );
                  } else if (fv !== 0 && fu !== 0) {
                    // Scenario 6: fund_value updated while units is already set
                    // — recalculate unit_price.
                    formik.setFieldValue(
                      "unit_price",
                      parseFloat((fv / fu).toFixed(4)),
                    );
                  }
                }
              }}
              disabled={
                selectedruleItem?.is_default === true ||
                selectedruleItem?.is_default === "true"
                  ? false
                  : fieldInfo.readOnly
              }
              value={
                formik.values[fieldInfo.name] !== undefined
                  ? formik.values[fieldInfo.name]
                  : ""
              }
              min={fieldInfo.min ?? undefined}
              max={fieldInfo.max ?? undefined}
              onChange={formik.handleChange}
              // Only the `amount` field carries a symbol, and which one is
              // decided by amount_flag: "%" after a percentage, the currency
              // symbol before a fixed money amount.
              //
              // Scoped via isPercentAmountField rather than reading the flag
              // directly — this is the generic number input, so an unscoped
              // read suffixed a stray "%" onto every numeric field on the form
              // (fund value, units, price) whenever a percentage rule was
              // loaded. The value itself stays raw either way: these are
              // adornments, not part of what the input holds or submits.
              contentBefore={
                isCurrencyElement(
                  element,
                  isPercentAmountField(element, formik.values),
                ) && element?.field === "amount" ? (
                  <strong>{getCurrencySymbol()}</strong>
                ) : null
              }
              contentAfter={
                isPercentAmountField(element, formik.values) ? (
                  <strong>%</strong>
                ) : null
              }
            />

            {props.primaryContactFields !== undefined &&
              props.primaryContactFields.length > 0 &&
              props.primaryContactFields.includes(element.field) && (
                <Checkbox
                  checked={
                    props.primaryContact === element.field ? true : false
                  }
                  value={element.field}
                  onChange={(ev: any, data: any) => {
                    setCheckedData(data.checked);
                    props.setFieldAsPrimary(
                      data.checked ? ev.target.value : "",
                    );
                  }}
                  label="Set as primary contact"
                />
              )}
          </Field>
        );
      }
      case "email":
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
                {props.primaryContactFields !== undefined &&
                  props.primaryContactFields.length > 0 &&
                  props.primaryContactFields.includes(element.field) && (
                    <>
                      {" ("}
                      <Checkbox
                        checked={
                          props.primaryContact === element.field ? true : false
                        }
                        value={element.field}
                        disabled={
                          formik?.values[fieldInfo.name] !== undefined &&
                          formik?.values[fieldInfo.name] !== null &&
                          formik?.values[fieldInfo.name] !== ""
                            ? false
                            : true
                        }
                        onChange={(ev: any, data: any) => {
                          setCheckedData(data.checked);
                          props.setFieldAsPrimary(
                            data.checked ? ev.target.value : "",
                          );
                        }}
                        label="Set as primary"
                      />
                      {")"}
                    </>
                  )}
              </>
            }
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
            // validationState="success"
          >
            <Input
              appearance="filled-lighter"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              name={fieldInfo.name}
              placeholder={fieldInfo.placeholder}
              disabled={fieldInfo.readOnly}
              value={
                formik?.values[fieldInfo.name] !== undefined
                  ? formik.values[fieldInfo.name]
                  : ""
              }
            />
            {/* {props.primaryContactFields !== undefined &&
              props.primaryContactFields.length > 0 &&
              props.primaryContactFields.includes(element.field) && (
                <Checkbox
                  checked={
                    props.primaryContact === element.field ? true : false
                  }
                  value={element.field}
                  onChange={(ev: any, data: any) => {
                    setCheckedData(data.checked);
                    props.setFieldAsPrimary(
                      data.checked ? ev.target.value : ""
                    );
                  }}
                  label="Set as primary contact"
                />
              )} */}
          </Field>
        );
        break;
      case "select":
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
                {props.primaryContactFields !== undefined &&
                  props.primaryContactFields.length > 0 &&
                  props.primaryContactFields.includes(element.field) && (
                    <>
                      {" ("}
                      <Checkbox
                        checked={
                          props.primaryContact === element.field ? true : false
                        }
                        value={element.field}
                        disabled={
                          formik?.values[fieldInfo.name] !== undefined &&
                          formik?.values[fieldInfo.name] !== null &&
                          formik?.values[fieldInfo.name] !== ""
                            ? false
                            : true
                        }
                        onChange={(ev: any, data: any) => {
                          setCheckedData(data.checked);
                          props.setFieldAsPrimary(
                            data.checked ? ev.target.value : "",
                          );
                        }}
                        label="Set as primary"
                      />
                      {")"}
                    </>
                  )}
              </>
            }
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
          >
            <Select
              id={selectId}
              appearance="filled-lighter"
              onChange={(e: any) => {
                const selectedIndex = e.target.selectedIndex;
                const selectedValue = e.target.value;
                const selectedLabel = e.target.options[selectedIndex].label;

                if (fieldInfo.name === "consultant_id") {
                  formik.setFieldValue(fieldInfo.name, selectedValue);
                  if (props.updateConsultantName !== undefined) {
                    props.updateConsultantName(selectedLabel);
                  }
                } else if (fieldInfo.name === "commission_type") {
                  formik.setFieldValue(fieldInfo.name, selectedLabel);
                  if (props.updateCommissionType !== undefined) {
                    props.updateCommissionType(selectedLabel);
                  }
                } else {
                  formik.setFieldValue(fieldInfo.name, selectedValue);
                }
              }}
              onBlur={formik.handleBlur}
              name={fieldInfo.name}
              disabled={fieldInfo.readOnly}
            >
              {[
                "ASSET_INVESTMENT_PAYMENTS_COMMISSION",
                "ASSET_SHAREHOLDINGS_PAYMENT_COMMISSION",
                "ASSET_BANK_OR_BUILDING_SOCIETIES_PAYMENT_COMMISSION",
                "LIABILITIES_MORTGAGES_PAYMENT_COMMISSION",
                "LIABILITIES_LOAN_HIRE_PURCHASE_PAYMENTS_COMMISSION",
                "LIABILITIES_CREDIT_CARDS_PAYMENTS_COMMISSION",
                "POLICIES_GENERAL_PAYMENTS_COMMISSION",
                "POLICIES_INVESTMENTS_PAYMENTS_COMMISSION",
                "POLICIES_INCOME_PROTECTION_COMMISSION",
                "POLICIES_PENSIONS_PAYMENTS_COMMISSION",
                "POLICIES_SAVINGS_PLANS_COMMISSION",
                "POLICIES_LIFE_ASSURANCE_PAYMENTS_COMMISSION",
              ].includes(props.context) &&
              fieldInfo.name === "commission_type" ? (
                <option value={0}>{""}</option>
              ) : (
                ""
              )}

              {options &&
                options.length > 0 &&
                options.map(
                  (optn: { label: string; value: string }, i: any) => (
                    <option
                      key={i}
                      value={optn.value}
                      label={
                        optn.label === "Unit-linked"
                          ? "Asset (Investment)"
                          : optn.label || ""
                      }
                      selected={
                        fieldInfo.name === "uk_residence"
                          ? ["1", 1, "Yes"].includes(
                              formik.values[fieldInfo.name],
                            )
                            ? optn.value.toString() === "1"
                            : ["0", 0, "No"].includes(
                                formik.values[fieldInfo.name],
                              ) && optn.value.toString() === "0"
                          : ["commission_type"].includes(fieldInfo.name)
                            ? formik.values[fieldInfo.name] === optn.label
                            : ["consultant_id"].includes(fieldInfo.name)
                              ? formik.values[fieldInfo.name] === optn.value
                              : [
                                    "applicable",
                                    "pending",
                                    "link_to_mortgage",
                                    "category",
                                  ].includes(fieldInfo.name)
                                ? (formik.values[fieldInfo.name]?.toString() ||
                                    "") === optn.value
                                : ["joint_indicator", "owner"].includes(
                                      fieldInfo.name,
                                    )
                                  ? (formik.values[
                                      fieldInfo.name
                                    ]?.toString() || "") === optn.value
                                  : formik.values[fieldInfo.name] === optn.value
                      }
                    />
                  ),
                )}
            </Select>

            {/* {props.primaryContactFields !== undefined &&
              props.primaryContactFields.length > 0 &&
              props.primaryContactFields.includes(element.field) && (
                <Checkbox
                  checked={
                    props.primaryContact === element.field ? true : false
                  }
                  value={element.field}
                  onChange={(ev: any, data: any) => {
                    setCheckedData(data.checked);
                    props.setFieldAsPrimary(
                      data.checked ? ev.target.value : ""
                    );
                  }}
                  label="Set as primary contact"
                />
              )} */}
          </Field>
        );
        break;
      case "datepicker":
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
                {props.primaryContactFields !== undefined &&
                  props.primaryContactFields.length > 0 &&
                  props.primaryContactFields.includes(element.field) && (
                    <>
                      {" ("}
                      <Checkbox
                        checked={
                          props.primaryContact === element.field ? true : false
                        }
                        value={element.field}
                        disabled={
                          formik?.values[fieldInfo.name] !== undefined &&
                          formik?.values[fieldInfo.name] !== null &&
                          formik?.values[fieldInfo.name] !== ""
                            ? false
                            : true
                        }
                        onChange={(ev: any, data: any) => {
                          setCheckedData(data.checked);
                          props.setFieldAsPrimary(
                            data.checked ? ev.target.value : "",
                          );
                        }}
                        label="Set as primary"
                      />
                      {")"}
                    </>
                  )}
              </>
            }
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationState={
              formik.errors[fieldInfo.name] &&
              formik.errors[fieldInfo.name] !== null
                ? "error"
                : "none"
            }
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined &&
              formik.errors[fieldInfo.name] !== null
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
          >
            {/* =========================================================================== */}
            {/* <div className={"date_picker"}>
              <DatePicker
                as="input"
                allowTextInput
                disabled={fieldInfo.readOnly}
                style={{ width: "100%" }}
                placeholder=""
                formatDate={onFormatDate}
                appearance="filled-lighter"
                onSelectDate={(date) => {
                  formik.setFieldValue(fieldInfo.name, date);
                  if (props.customHandleChange !== undefined) {
                    props.customHandleChange({
                      target: { name: fieldInfo.name, value: date },
                    });
                  }
                }}
                onBlur={formik.handleBlur}
                maxDate={
                  element.maxDate !== undefined
                    ? validateMaxMinDate(element.maxDate)
                    : undefined
                }
                minDate={
                  element.minDate !== undefined
                    ? validateMaxMinDate(element.minDate)
                    : undefined
                }
                name={fieldInfo.name}
                value={
                  formik?.values[fieldInfo.name]
                    ? props.mode === "add"
                      ? formik?.values[fieldInfo.name]
                      : props.mode === "edit"
                      ? new Date(formik?.values[fieldInfo.name])
                      : null
                    : null
                }
                firstDayOfWeek={DayOfWeek.Monday}
              />
              {formik.values[fieldInfo.name] && !fieldInfo.readOnly ? (
                <div>
                  <DismissFilled onClick={handleClearDate} />
                </div>
              ) : (
                ""
              )}
            </div> */}
            {/* =========================================================================== */}
            <ControlledDatePicker
              formik={formik}
              fieldInfo={fieldInfo}
              mode={props.mode}
              customHandleChange={props.customHandleChange}
            />

            {/* {props.primaryContactFields !== undefined &&
              props.primaryContactFields.length > 0 &&
              props.primaryContactFields.includes(element.field) && (
                <Checkbox
                  checked={
                    props.primaryContact === element.field ? true : false
                  }
                  value={element.field}
                  onChange={(ev: any, data: any) => {
                    setCheckedData(data.checked);
                    props.setFieldAsPrimary(
                      data.checked ? ev.target.value : ""
                    );
                  }}
                  label="Set as primary contact"
                />
              )} */}
          </Field>
        );
        break;
      case "text-area":
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
                {props.primaryContactFields !== undefined &&
                  props.primaryContactFields.length > 0 &&
                  props.primaryContactFields.includes(element.field) && (
                    <>
                      {" ("}
                      <Checkbox
                        checked={
                          props.primaryContact === element.field ? true : false
                        }
                        value={element.field}
                        disabled={
                          formik?.values[fieldInfo.name] !== undefined &&
                          formik?.values[fieldInfo.name] !== null &&
                          formik?.values[fieldInfo.name] !== ""
                            ? false
                            : true
                        }
                        onChange={(ev: any, data: any) => {
                          setCheckedData(data.checked);
                          props.setFieldAsPrimary(
                            data.checked ? ev.target.value : "",
                          );
                        }}
                        label="Set as primary"
                      />
                      {")"}
                    </>
                  )}
              </>
            }
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
            // validationState="success"
          >
            <Textarea
              appearance="filled-lighter"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              name={fieldInfo.name}
              placeholder={fieldInfo.placeholder}
              disabled={fieldInfo.readOnly}
              value={
                formik?.values[fieldInfo.name] !== undefined
                  ? formik.values[fieldInfo.name]
                  : ""
              }
            />
            {/* {props.primaryContactFields !== undefined &&
              props.primaryContactFields.length > 0 &&
              props.primaryContactFields.includes(element.field) && (
                <Checkbox
                  checked={
                    props.primaryContact === element.field ? true : false
                  }
                  value={element.field}
                  onChange={(ev: any, data: any) => {
                    setCheckedData(data.checked);
                    props.setFieldAsPrimary(
                      data.checked ? ev.target.value : ""
                    );
                  }}
                  label="Set as primary contact"
                />
              )} */}
          </Field>
        );
        break;
      case "check-box":
        return (
          <div>
            <Field
              orientation={props.isAdminForm ? "horizontal" : "vertical"}
              validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
              validationMessage={`${
                formik.errors[fieldInfo.name] !== undefined
                  ? formik.errors[fieldInfo.name]
                  : ""
              }`}
              // validationState="success"
            >
              <Checkbox
                checked={checked}
                onChange={() => setChecked((checked) => !checked)}
                label={
                  <>
                    {element.required !== undefined && element.required ? (
                      <span>
                        {element.label} <span className="required-item">*</span>
                      </span>
                    ) : (
                      <span> {element.label}</span>
                    )}
                  </>
                }
              />
            </Field>
          </div>
        );
        break;
      case "select-with-selectionList":
        const handleSelectWithParam = (inputValue: string) => {
          handleCreate(inputValue, fieldInfo.name);
        };
        return (
          <div>
            <Field
              orientation={props.isAdminForm ? "horizontal" : "vertical"}
              validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
              validationMessage={`${
                formik.errors[fieldInfo.name] !== undefined
                  ? formik.errors[fieldInfo.name]
                  : ""
              }`}
              label={
                <>
                  {element.required !== undefined && element.required ? (
                    <span>
                      {element.label} <span className="required-item">*</span>
                    </span>
                  ) : (
                    <span> {element.label}</span>
                  )}
                </>
              }
              // validationState="success"
            >
              <div
                style={{
                  display: "flex",
                  gap: 4,
                  alignItems: "center",
                }}
              >
                {element.prefix !== undefined && (
                  <Select
                    id={selectId}
                    appearance="filled-lighter"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    name={element.prefix.field}
                    style={{ width: "30%" }}
                  >
                    {props.prefixOptions !== undefined &&
                    props.prefixOptions.length > 0
                      ? props.prefixOptions.map(
                          (optn: { label: string; value: string }, i: any) => (
                            <option
                              key={i}
                              value={optn.value}
                              label={optn.label || optn.value}
                              selected={
                                formik.values[element.prefix.field] ==
                                optn.value
                                  ? true
                                  : false
                              }
                            />
                          ),
                        )
                      : element.prefix.options.map(
                          (optn: { label: string; value: string }, i: any) => (
                            <option
                              key={i}
                              value={optn.value}
                              label={optn.label || optn.value}
                              selected={
                                formik.values[element.prefix.field] ==
                                optn.value
                                  ? true
                                  : false
                              }
                            />
                          ),
                        )}
                  </Select>
                )}

                <CreatableSelect
                  styles={{
                    container: (base: any) => ({
                      ...base,
                      width: "100%",
                    }),
                    control: (baseStyles: any, state) => ({
                      ...baseStyles,
                      border: formik.errors[fieldInfo.name]
                        ? "1px solid #bc2f32"
                        : "none",
                      padding: "0px",
                      minHeight: "32px !important",
                      height: "32px",
                      alignItems: "baseline",
                    }),
                    input: (base: any) => ({
                      ...base,
                      overflow: "auto",
                    }),
                    indicatorsContainer: (base: any) => ({
                      ...base,
                      height: "32px",
                    }),
                    menu: (base: any) => ({
                      ...base,
                      zIndex: 99999999,
                    }),
                  }}
                  isClearable
                  isDisabled={isLoading}
                  isLoading={isLoading}
                  name={fieldInfo.name}
                  value={
                    props.mode === "add"
                      ? value
                      : props.mode === "edit"
                        ? options.find(
                            (opt) =>
                              opt.value === formik.values[fieldInfo.name],
                          )
                        : null
                  }
                  onChange={(newValue) => {
                    if (!newValue) {
                      formik.setFieldValue(fieldInfo.name, "");
                      setValue(null);
                      props.newSelectOptionAdded?.(
                        fieldInfo.name,
                        "",
                        "remove",
                      );
                    } else {
                      formik.setFieldValue(fieldInfo.name, newValue.value);
                      setValue(newValue);
                      props.customHandleChange?.({
                        target: { name: fieldInfo.name, value: newValue.value },
                      });
                    }
                  }}
                  onCreateOption={handleSelectWithParam}
                  options={options}
                  formatCreateLabel={(inputValue: string) => `${inputValue}`}
                />
              </div>
            </Field>
          </div>
        );
        break;
      case "selectionList":
        const handleCreateWithParam = (inputValue: string) => {
          handleCreate(inputValue, fieldInfo.name);
        };

        // const foundObject: Option | undefined = value.find(obj => obj.value === formik.values[fieldInfo.name]);
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
              </>
            }
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
          >
            <CreatableSelect
              styles={{
                control: (baseStyles: any, state) => ({
                  ...baseStyles,
                  border: formik.errors[fieldInfo.name]
                    ? "1px solid #bc2f32"
                    : "none",
                  padding: "0px",
                  minHeight: "32px !important",
                  height: "32px",
                  alignItems: "baseline",
                }),
                input: (base: any) => ({
                  ...base,
                  overflow: "auto",
                }),
                indicatorsContainer: (base: any) => ({
                  ...base,
                  height: "32px",
                }),
                menu: (base: any) => ({
                  ...base,
                  zIndex: 99999999,
                }),
              }}
              isClearable
              isDisabled={
                review &&
                checkUserPermission(
                  loggedUser,
                  UserPermissionsList.ALLOW_REASSIGN_ACTIONS,
                ) === false
              }
              isLoading={isLoading}
              name={fieldInfo.name}
              value={
                props.mode === "add"
                  ? value
                  : props.mode === "edit"
                    ? options.find(
                        (opt) => opt.value === formik.values[fieldInfo.name],
                      )
                    : null
              }
              onChange={(newValue) => {
                if (!newValue) {
                  formik.setFieldValue(fieldInfo.name, "");
                  setValue(null);
                  props.newSelectOptionAdded?.(fieldInfo.name, "", "remove");
                } else {
                  formik.setFieldValue(fieldInfo.name, newValue.value);
                  setValue(newValue);
                  props.customHandleChange?.({
                    target: { name: fieldInfo.name, value: newValue.value },
                  });
                }
              }}
              onCreateOption={handleCreateWithParam}
              options={options}
              formatCreateLabel={(inputValue: string) => `${inputValue}`}
            />
          </Field>
        );
        break;
      case "timePicker":
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
              </>
            }
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
          >
            <TimePicker
              name={fieldInfo.name}
              selected={
                formik.values[fieldInfo.name]
                  ? parseTime(formik.values[fieldInfo.name], fieldInfo.name)
                  : props.timeCleared
                    ? null
                    : new Date()
              }
              onChange={(date) => {
                if (!date || isNaN(date.getTime())) return;
                props.setTimeCleared(false);
                if (fieldInfo.name === "duration") {
                  // Save as UTC ISO string representing local time
                  // with today's date but same time components
                  const year = new Date().getFullYear();
                  const month = String(new Date().getMonth() + 1).padStart(
                    2,
                    "0",
                  );
                  const day = String(new Date().getDate()).padStart(2, "0");

                  const hours = String(date.getHours()).padStart(2, "0");
                  const minutes = String(date.getMinutes()).padStart(2, "0");
                  const seconds = timeAllocation
                    ? String(date.getSeconds()).padStart(2, "0")
                    : "00";

                  const durationValue = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;
                  formik.setFieldValue(fieldInfo.name, durationValue);
                } else {
                  formik.setFieldValue(fieldInfo.name, date.toISOString());
                }

                if (props.customHandleChange) {
                  props.customHandleChange({
                    target: { name: fieldInfo.name, value: date },
                  });
                }
              }}
              onChangeRaw={(e) => {
                if (!e.target.value) {
                  props.setTimeCleared(true);
                  formik.setFieldValue(fieldInfo.name, null);
                  props.customHandleChange?.({
                    target: { name: fieldInfo.name, value: null },
                  });
                  return;
                }
                handleManualInput(e.target.value);
              }}
              className="timepicker-style"
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat={timeAllocation ? "HH:mm:ss" : "HH:mm"}
              timeFormat={timeAllocation ? "HH:mm:ss" : "HH:mm"}
              placeholderText={timeAllocation ? "HH:MM:SS" : "HH:mm"}
            />
          </Field>
        );
        break;
      case "fileUpload":
        {
          const getFileLinkError = (path: string) => {
            if (!path) return "";
            if (
              /^\\{3,}/.test(path) ||
              (/^\/{3,}/.test(path) && !path.startsWith("file:///"))
            )
              return "Invalid path format. Path starts with too many separators.";
            if (path.startsWith("file://") && !path.startsWith("file:///"))
              return "File URI must use three slashes (e.g. file:///path/to/file).";
            if (/^[a-zA-Z]:[^/\\]/.test(path))
              return "Windows drive letter must be followed by a separator (e.g. C:\\...).";
            if (/[/\\]$/.test(path))
              return "File paths must not end with '/' or '\\'.";
            if (/[<>"|?*]/.test(path))
              return 'Path contains invalid characters (< > " | ? *).';
            if (!/\.[a-zA-Z0-9]+$/.test(path))
              return "File path must include a file extension (e.g. .pdf, .docx).";
            if (/[ ]+$/.test(path))
              return "Invalid format. Trailing spaces found at the end of the path.";
            return "";
          };
          const fileLinkError = getFileLinkError(fileLinkPath);
          const applyFileLinkValue = (val: string) => {
            setFileLinkPath(val);
            formik.setFieldValue("referencePath", val);
            const err = getFileLinkError(val);
            // setTimeout(0) ensures setFieldError runs AFTER Formik's internal
            // validation (triggered by setFieldValue) which would otherwise clear it
            setTimeout(() => {
              formik.setFieldError("referencePath", err || undefined);
            }, 0);
            if (props.customHandleChange !== undefined) {
              props.customHandleChange({
                target: { name: "referencePath", value: val },
              });
            }
          };
          return (
            <div style={{ position: "relative" }}>
              {isPickerLoading && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: "rgba(255,255,255,0.75)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 10,
                    borderRadius: 6,
                    gap: 8,
                  }}
                >
                  <Spinner size="medium" />
                  <span style={{ fontSize: 13, color: "#475569" }}>
                    Please wait…
                  </span>
                </div>
              )}
              <Field
                label={
                  <>
                    {element.required !== undefined && element.required ? (
                      <span>
                        {element.label} <span className="required-item">*</span>
                      </span>
                    ) : (
                      <span> {element.label}</span>
                    )}
                  </>
                }
                orientation={props.isAdminForm ? "horizontal" : "vertical"}
                validationState={
                  formik.errors[fieldInfo.name] ? "error" : "none"
                }
                validationMessage={`${
                  formik.errors[fieldInfo.name] !== undefined
                    ? formik.errors[fieldInfo.name]
                    : ""
                }`}
              >
                <RadioGroup
                  layout="horizontal"
                  value={uploadMode ?? ""}
                  onChange={(_, data) => {
                    const mode = data.value as "upload" | "fileLink";
                    setUploadMode(mode);
                    formik.setFieldValue(fieldInfo.name, "");
                    formik.setFieldValue(
                      "file_source",
                      mode === "upload" ? "UPLOAD" : "REFERENCE",
                    );
                    if (mode === "fileLink") {
                      // switching to fileLink: restore original path, clear upload artifacts
                      setFileLinkPath(originalRefPath.current);
                      formik.setFieldValue("attachments", []);
                      props?.setUploadedFiles?.([]);
                    } else {
                      // switching to upload: clear file link artifacts and previous attachments
                      setFileLinkPath("");
                      formik.setFieldValue("referencePath", "");
                      formik.setFieldValue("attachments", []);
                      props?.setUploadedFiles?.([]);
                    }
                    setRawFiles([]);
                    setScannedFiles([]);
                  }}
                  style={{ marginBottom: "8px" }}
                >
                  <Radio value="upload" label="Upload" />
                  <Radio value="fileLink" label="File Link" />
                </RadioGroup>

                {uploadMode === "upload" && (
                  <>
                    {props.mode === "edit" &&
                      ["FACT_FIND_NOTES", "CONTACTS_NOTES"].includes(
                        props.context,
                      ) &&
                      formik.values.attachments?.length > 0 &&
                      rawFiles.length === 0 && (
                        <div style={{ marginBottom: "8px" }}>
                          {formik.values.attachments.map(
                            (doc: any, index: number) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  padding: "6px 10px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  backgroundColor: "#f9f9f9",
                                  marginBottom: "4px",
                                }}
                              >
                                <span style={{ flex: 1 }}>
                                  {getFileNameFromUrl(doc?.DocumentTitle || "")}
                                </span>

                                <Dismiss12Filled
                                  onClick={() => {
                                    formik.setFieldValue("attachments", []);
                                    formik.setFieldValue(fieldInfo.name, "");
                                    formik.setFieldValue(
                                      "file_source",
                                      "UPLOAD",
                                    );
                                    props?.setUploadedFiles?.([]);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "#cc0000",
                                    flexShrink: 0,
                                  }}
                                  title="Remove file"
                                />
                              </div>
                            ),
                          )}
                        </div>
                      )}
                    <Dropzone
                      onDrop={(acceptedFiles: File[]) => {
                        if (acceptedFiles.length > 0) {
                          setRawFiles([acceptedFiles[0]]);
                        }
                      }}
                      multiple={false}
                      disabled={scannedFiles.some(
                        (f: any) =>
                          f.status === "uploading" || f.status === "scanning",
                      )}
                    >
                      {({ getRootProps, getInputProps }) => {
                        const isProcessing = scannedFiles.some(
                          (f: any) =>
                            f.status === "uploading" || f.status === "scanning",
                        );
                        return (
                          <section>
                            <div
                              {...getRootProps()}
                              className="fileupload-container"
                              style={{
                                opacity: isProcessing ? 0.4 : 1,
                                pointerEvents: isProcessing ? "none" : "auto",
                                cursor: isProcessing
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              <input {...getInputProps()} />
                              <div className="file-upload">
                                <img src={UploadIcon} width={40} />
                              </div>
                              <p style={{ textAlign: "center" }}>
                                {isProcessing
                                  ? "File is being processed..."
                                  : "Click or Drag the file here to upload"}
                              </p>
                            </div>
                          </section>
                        );
                      }}
                    </Dropzone>

                    <DynamicDropzone
                      style={{ marginTop: "8px" }}
                      multiple={false}
                      externalFiles={rawFiles}
                      onFilesChange={(files: any) => {
                        setScannedFiles(files);
                        const isProcessing = files.some(
                          (f: any) =>
                            f.status === "uploading" || f.status === "scanning",
                        );
                        props?.setIsFileScanning?.(isProcessing);
                        const objectIds = files
                          .filter((f: any) => f.objectId)
                          .map((f: any) => f.objectId)
                          .join(",");
                        props?.setScannedObjectIds?.(objectIds);
                        const successFile = files.find(
                          (f: any) => f.status === "success",
                        );
                        if (successFile) {
                          props?.setUploadedFiles([successFile.file]);
                          formik.setFieldValue(
                            fieldInfo.name,
                            successFile.file,
                          );
                          if (props.customHandleChange !== undefined) {
                            props.customHandleChange({
                              target: {
                                name: fieldInfo.name,
                                value: successFile.file,
                              },
                            });
                          }
                        } else if (files.length === 0) {
                          props?.setUploadedFiles([]);
                          formik.setFieldValue(fieldInfo.name, "");
                        }
                      }}
                      userId={userId}
                    />
                  </>
                )}

                {uploadMode === "fileLink" && (
                  <Field
                    validationState={fileLinkError ? "error" : "none"}
                    validationMessage={fileLinkError}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "stretch", // Ensures buttons match input height
                        border: "1px solid #d1d5db", // Outer border
                        borderRadius: "8px", // Matches the screenshot's rounded corners
                        overflow: "hidden", // Clips the buttons/input to the border radius
                        width: "100%",
                      }}
                    >
                      {/* Input Section */}
                      <div
                        style={{
                          flex: 1,
                          minWidth: 0,
                          borderColor: "#e2e8f0",
                          borderRight: "1px solid #e2e8f0",
                        }}
                      >
                        <Input
                          placeholder="e.g. C:\Users\John\Documents\file.pdf or file:/home/user/file.pdf"
                          value={fileLinkPath}
                          style={{ width: "100%", height: "100%" }}
                          onPaste={(e) => {
                            e.preventDefault();
                            applyFileLinkValue(
                              sanitizePath(
                                e.clipboardData.getData("text/plain"),
                              ),
                            );
                          }}
                          onChange={(e) => {
                            applyFileLinkValue(sanitizePath(e.target.value));
                          }}
                          contentAfter={
                            fileLinkPath ? (
                              <Dismiss16Regular
                                style={{ cursor: "pointer", color: "#888" }}
                                onClick={() => applyFileLinkValue("")}
                              />
                            ) : undefined
                          }
                        />
                      </div>

                      {/* Button Group */}
                      <div style={{ display: "flex", alignItems: "stretch" }}>
                        {/* Info Button */}
                        <Tooltip
                          content="This stores the reference path of the target file or folder. You can access it by copying the path and pasting it into File Explorer, or by using the File Link app to directly open the corresponding file or folder."
                          relationship="description"
                          positioning="below"
                        >
                          <Button
                            appearance="subtle"
                            icon={<InfoRegular />}
                            style={{
                              borderRadius: 0,
                              borderLeft: "1px solid #e2e8f0",
                              background: "#f3f4f6", // Light grey tint from screenshot
                              color: "#888",
                            }}
                          />
                        </Tooltip>

                        {/* Copy Button */}
                        <Tooltip
                          content="Copy path"
                          relationship="label"
                          positioning="below"
                        >
                          <Button
                            appearance="subtle"
                            icon={<Copy20Regular />}
                            style={{
                              borderRadius: 0,
                              borderLeft: "1px solid #e2e8f0",
                              background: "#f3f4f6",
                              color: "#888",
                            }}
                            disabled={!fileLinkPath}
                            onClick={() => {
                              if (!fileLinkPath) return;
                              navigator.clipboard
                                .writeText(fileLinkPath)
                                .catch(() => {});
                              showToast(
                                "Path copied to clipboard",
                                "",
                                "success",
                              );
                            }}
                          />
                        </Tooltip>

                        {/* Browse Button */}
                        <Tooltip
                          content="Browse with Assyst File Link"
                          relationship="label"
                          positioning="below"
                        >
                          <Button
                            appearance="subtle"
                            icon={
                              isPickerLoading ? (
                                <Spinner size="tiny" />
                              ) : (
                                <FolderOpenRegular />
                              )
                            }
                            style={{
                              borderRadius: 0,
                              borderLeft: "1px solid #bfdbfe",
                              background: "#eff6ff",
                              color: "#1d4ed8",
                            }}
                            disabled={isPickerLoading}
                            onClick={async () => {
                              const path = await pickFile({
                                mode: "file",
                                onNotInstalled: () => setAssystLinkOpen(true),
                                onUpdateAvailable: () =>
                                  setAssystLinkOpen(true),
                              });
                              if (path) applyFileLinkValue(path);
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </Field>
                )}
              </Field>
            </div>
          );
        }
        break;
      case "text-editor":
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
              </>
            }
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
          >
            <div className="note_field">
              <TextEditor
                inputData={
                  props.mode === "add"
                    ? ""
                    : formik.values[fieldInfo.name] || ""
                }
                onChange={HandleNoteChange}
                name={fieldInfo.name}
                style={{ width: "100%" }}
              />

              <div>
                {formik.values[fieldInfo.name]?.length ?? 0}/{fieldInfo.max}
              </div>
            </div>
          </Field>
        );
        break;
      case "toggle-button":
        return (
          <Switch
            checked={
              formik?.values[fieldInfo.name] !== undefined
                ? formik?.values[fieldInfo.name] == 0
                  ? false
                  : true
                : toggle
            }
            name={fieldInfo.name}
            label={element.label}
            labelPosition="before"
            onChange={(ev) => {
              setToggle(!toggle);
              formik.setFieldValue(fieldInfo.name, ev.target.checked ? 1 : 0);
            }}
          />
        );
        break;
      default:
        return (
          <Field
            label={
              <>
                {element.required !== undefined && element.required ? (
                  <span>
                    {element.label} <span className="required-item">*</span>
                  </span>
                ) : (
                  <span> {element.label}</span>
                )}
                {props.primaryContactFields !== undefined &&
                  props.primaryContactFields.length > 0 &&
                  props.primaryContactFields.includes(element.field) && (
                    <>
                      {" ("}
                      <Checkbox
                        checked={
                          props.primaryContact === element.field ? true : false
                        }
                        value={element.field}
                        onChange={(ev: any, data: any) => {
                          setCheckedData(data.checked);
                          props.setFieldAsPrimary(
                            data.checked ? ev.target.value : "",
                          );
                        }}
                        label="Set as primary"
                      />
                      {")"}
                    </>
                  )}
              </>
            }
            orientation={props.isAdminForm ? "horizontal" : "vertical"}
            validationState={formik.errors[fieldInfo.name] ? "error" : "none"}
            validationMessage={`${
              formik.errors[fieldInfo.name] !== undefined
                ? formik.errors[fieldInfo.name]
                : ""
            }`}
            // validationState="success"
          >
            <Input
              appearance="filled-lighter"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              name={fieldInfo.name}
              placeholder={fieldInfo.placeholder}
              disabled={fieldInfo.readOnly}
              value={
                formik?.values[fieldInfo.name] !== undefined
                  ? formik.values[fieldInfo.name]
                  : ""
              }
            />
            {/* {props.primaryContactFields !== undefined &&
              props.primaryContactFields.length > 0 &&
              props.primaryContactFields.includes(element.field) && (
                <Checkbox
                  checked={
                    props.primaryContact === element.field ? true : false
                  }
                  value={element.field}
                  onChange={(ev: any, data: any) => {
                    setCheckedData(data.checked);
                    props.setFieldAsPrimary(
                      data.checked ? ev.target.value : ""
                    );
                  }}
                  label="Set as primary contact"
                />
              )} */}
          </Field>
        );
        break;
    }
  };
  const [documentTitle, setDocumentTitle] = useState("");
  const handleDownload = (fileId: string) => {
    apiServices.document
      .getDocument(fileId, props?.customer_id)
      .then((res) => {
        if (res.data && res.data.data) {
          const { DocumentId, DocumentTitle } = res.data.data;
          setDocumentTitle(DocumentTitle);
          handleFileDownload(
            DocumentId,
            DocumentTitle || "",
            apiServices.documentDownload.download,
          );
        }
      })
      .catch((err: any) => console.log(err));
  };
  const showElement = (element: any) => {
    const fieldInfo = {
      name: element.field,
      label: element.label,
    };
    if (element.type === "datepicker") {
      return (
        <div className={classes.fieldWrapper}>
          <Label weight="semibold" size="medium">
            {element.label}
          </Label>
          <Label>{formatedDate(formik.values[fieldInfo.name])}</Label>
        </div>
      );
    } else if (element.type === "number") {
      const isPercent = isPercentAmountField(element, formik.values);
      const isCurrency = isCurrencyElement(element, isPercent);

      return (
        <div className={classes.fieldWrapper}>
          <Label weight="semibold" size="medium">
            {element.label}
          </Label>

          <Label>
            {isPercent
              ? formatPercent(formik.values[fieldInfo.name]) ||
                formik.values[fieldInfo.name]
              : isCurrency
                ? formatGBPOrPassThrough(formik.values[fieldInfo.name])
                : formik.values[fieldInfo.name]}
          </Label>
        </div>
      );
    } else if (element.type === "text-editor") {
      return (
        <div className={`${classes.fieldWrapper}`}>
          <Label weight="semibold" size="medium">
            {element.label}
          </Label>
          <NoteViewer value={formik.values[fieldInfo.name]} />
        </div>
      );
    } else if (element.type === "selectionList") {
      return (
        <div className={`${classes.fieldWrapper}`}>
          <Label weight="semibold" size="medium">
            {element.label}
          </Label>
          <NoteViewer value={formik.values[fieldInfo.name]} />
        </div>
      );
    } else if (element.type === "fileUpload") {
      // apiServices.notes.getById()
      return (
        <div className={classes.fieldWrapper}>
          <Label weight="semibold" size="medium">
            {element.label}
          </Label>
          <div>
            {formik.values.file_source === "REFERENCE" ? (
              <>
                {formik.values.attachments &&
                formik.values.attachments.length > 0
                  ? formik.values.attachments.map((doc: any, index: number) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                          marginTop: "6px",
                          marginLeft: "1px",
                        }}
                      >
                        <span>{getFileNameFromUrl(doc?.FileLink || "")}</span>
                        <Tooltip content="Copy path" relationship="label">
                          <span
                            className="filelink-info-icon"
                            role="button"
                            aria-label="Copy"
                          >
                            <Copy20Regular
                              style={{ cursor: "pointer", flexShrink: 0 }}
                              onClick={() => {
                                if (navigator?.clipboard?.writeText) {
                                  navigator.clipboard
                                    .writeText(doc?.FileLink)
                                    .then(() => {
                                      showToast(
                                        "Path copied to clipboard",
                                        "",
                                        "success",
                                      );
                                    });
                                } else {
                                  const textarea =
                                    document.createElement("textarea");
                                  textarea.value = doc?.FileLink;
                                  textarea.style.position = "fixed";
                                  textarea.style.opacity = "0";
                                  document.body.appendChild(textarea);
                                  textarea.focus();
                                  textarea.select();
                                  document.execCommand("copy");
                                  document.body.removeChild(textarea);
                                  showToast(
                                    "Path copied to clipboard",
                                    "",
                                    "success",
                                  );
                                }
                              }}
                            />
                          </span>
                        </Tooltip>
                        <Tooltip
                          content="Open in file explorer"
                          relationship="description"
                        >
                          <FolderOpenRegular
                            className="filelink-info-icon"
                            onClick={async () => {
                              if (!doc?.FileLink) return;
                              await openFile(doc.FileLink, {
                                onNotInstalled: () => setAssystLinkOpen(true),
                                onError: (message) =>
                                  showToast(message, "", "error"),
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    ))
                  : "-"}
              </>
            ) : formik.values.file_source === "UPLOAD" ? (
              <>
                {formik.values.attachments &&
                formik.values.attachments.length > 0
                  ? formik.values.attachments.map((doc: any, index: number) => (
                      <div key={index}>
                        <span>
                          {getFileNameFromUrl(doc?.DocumentTitle || "")}
                        </span>
                        <span
                          onClick={() => handleDownload(doc.DocumentId)}
                          style={{
                            cursor: "pointer",
                            color: "blue",
                            textDecoration: "underline",
                            marginLeft: "10px",
                          }}
                        >
                          Download
                        </span>
                      </div>
                    ))
                  : "-"}
              </>
            ) : (
              "-"
            )}
          </div>
        </div>
      );
    } else if (element.type === "text-area") {
      return (
        <div className={classes.fieldWrapper}>
          <Label weight="semibold" size="medium">
            {element.label}
          </Label>
          <Label>{formik.values[fieldInfo.name]}</Label>
          {/* <NoteViewer value={formik.values[fieldInfo.name]} /> */}
        </div>
      );
    } else if (element.type === "toggle-button") {
      return (
        <div className={classes.fieldWrapper}>
          <Label weight="semibold" size="medium">
            {element.label}
          </Label>
          <Label>{formik.values[fieldInfo.name] === 0 ? "No" : "Yes"}</Label>
        </div>
      );
    } else if (element.type === "select") {
      const getFieldValue = () => {
        const fieldMapping: { [key: string]: any } = {
          consultant_id: formik.values.consultant,
          commission_type: formik.values.commission_type,
        };

        if (fieldInfo.name in fieldMapping) {
          return fieldMapping[fieldInfo.name];
        }

        if (["applicable", "pending"].includes(fieldInfo.name)) {
          return formik.values[fieldInfo.name] === 0 ? "No" : "Yes";
        }

        return formik.values[fieldInfo.name];
      };

      return (
        <div className={classes.fieldWrapper}>
          <Label weight="semibold" size="medium">
            {element.label}
          </Label>
          <Label>{getFieldValue()}</Label>
        </div>
      );
    } else {
      // Covers the monetary fields still declared as `type: "text"` in
      // form-collections (current_value, property_value, surrender_value, …).
      //
      // `amount_flag` has to be honoured here too, not just in the `number`
      // branch: the commission rule's `amount` is declared `type: "text"` with
      // `"format": "currency"`, so without this the metadata wins and a
      // percentage rule renders as "£5.00" instead of "5 %".
      const isPercent = isPercentAmountField(element, formik.values);
      const isCurrency = isCurrencyElement(element, isPercent);

      return (
        <div className={classes.fieldWrapper}>
          <Label weight="semibold" size="medium">
            {element.label}
          </Label>
          <Label>
            {isPercent
              ? formatPercent(formik.values[fieldInfo.name]) ||
                formik.values[fieldInfo.name]
              : isCurrency
                ? formatGBPOrPassThrough(formik.values[fieldInfo.name])
                : formik.values[fieldInfo.name]}
          </Label>
        </div>
      );
    }
  };

  return (
    <>
      <div>
        {props?.mode && props?.mode === "view"
          ? showElement(props?.item)
          : getElement(props?.item)}
      </div>
      <Dialog modalType="non-modal" open={openTextEditor}>
        <DialogSurface aria-describedby={undefined}>
          <DialogBody>
            <DialogTitle>Dialog title</DialogTitle>
            <DialogContent>
              <TextEditor />
            </DialogContent>
            <DialogActions>
              <DialogTrigger disableButtonEnhancement>
                <ASCButton
                  shape="rounded"
                  appearance="secondary"
                  onClick={() => {
                    setOpenTextEditor(false);
                  }}
                  label="Close"
                />
              </DialogTrigger>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
      <Dialog modalType="non-modal" open={openProviderList}>
        <DialogSurface aria-describedby={undefined}>
          <DialogBody>
            <DialogContent>
              <Provider
                providerId={providerId}
                options={providerDialogOptions}
                setSelectedProviderItem={setSelectedProviderItem}
              />
            </DialogContent>
            <DialogActions>
              <DialogTrigger disableButtonEnhancement>
                <ASCButton
                  shape="rounded"
                  size="medium"
                  className="asc-button-primary"
                  appearance={"primary"}
                  onClick={() => {
                    selectedProvider();
                    setOpenProviderList(false);
                  }}
                  label="Submit"
                />
              </DialogTrigger>
              <DialogTrigger disableButtonEnhancement>
                <ASCButton
                  shape="rounded"
                  appearance="secondary"
                  size="medium"
                  onClick={() => {
                    const snap = providerSnapshotRef.current;

                    // Restore local state
                    setProviderName(snap.providerName);
                    setGetProviderId(snap.getProviderId);
                    setSelectedProviderItem(snap.selectedProviderItem);

                    // 🔥 Restore formik in one go
                    formik.setValues({
                      ...formik.values,
                      provider_correspondence: snap.provider_correspondence,
                      provider_name: snap.provider_name,
                    });

                    setOpenProviderList(false);
                  }}
                  label="Cancel"
                />
              </DialogTrigger>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
      <AssystLinkModal
        open={assystLinkOpen}
        onClose={() => setAssystLinkOpen(false)}
        needsUpdate={needsUpdate}
        latestVersion={latestVersion}
        platform={platform}
        installerName={installerName}
        downloadUrl={downloadUrl}
      />
      <Toaster
        toasterId={toasterId}
        position="top-end"
        pauseOnHover
        timeout={3000}
      />
    </>
  );
};

export default RenderFormElements;
